import React, { Component } from 'react'

import { withStyles } from "@material-ui/core/styles"

import Grid from '@material-ui/core/Grid'
import GridContainer from './GridContainer'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Button from '@material-ui/core/Button'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'

import iddLogoBw from './../../assets/images/idd-logo-bw.png'

import './Footer.css'
import { Typography } from '@material-ui/core';

const styles = {
    appBar: {
        bottom: 0,
        right: 0,
        left: 0
    }
  }

class Footer extends Component {

  constructor(props) {
      super(props)
  }  
    
  render() {

    const { classes } = this.props

    return (
        <AppBar className={`shared-footer ${classes.appBar}`} position="static" color="default">
            <Toolbar disableGutters={true}>

                <GridContainer>
                    <Grid item xs={12} sm={3}>
                        <img src={iddLogoBw} className="shared-footer__logo"/>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <List className="shared-footer__link-list">
                            <ListItem><strong>IDD</strong></ListItem>
                            <ListItem><Button size="small" href="https://www.destinazionedigitale.it/chi-siamo/">Chi Siamo</Button></ListItem>
                            <ListItem><Button size="small" href="https://www.destinazionedigitale.it/magazine/">Magazine</Button></ListItem>
                            <ListItem><Button size="small" href="https://www.destinazionedigitale.it/le-ricerche/">Ricerche</Button></ListItem>
                            <ListItem><Button size="small" href="https://www.destinazionedigitale.it/il-premio/">Il Premio</Button></ListItem>
                            <ListItem><Button size="small" href="https://www.destinazionedigitale.it/contatti/">Contatti</Button></ListItem>
                        </List>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <List className="shared-footer__link-list">
                            <ListItem><strong>IL PREMIO</strong></ListItem>
                            <ListItem><Button size="small" href="https://www.destinazionedigitale.it/edizione2018/">Edizione 2018</Button></ListItem>
                            <ListItem><Button size="small" href="https://www.destinazionedigitale.it/edizione2017/">Edizione 2017</Button></ListItem>
                            <ListItem><Button size="small" href="https://www.destinazionedigitale.it/edizione2016/">Edizione 2016</Button></ListItem>
                        </List>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <List className="shared-footer__link-list">
                            <ListItem><strong>ULTIME RICERCHE</strong></ListItem>
                            <ListItem><Button size="small" href="https://www.destinazionedigitale.it/cosa-si-dice-dei-ristoranti-di-italia-report-2017/">Cosa si dice dei Ristoranti d’Italia</Button></ListItem>
                            <ListItem><Button size="small" href="https://www.destinazionedigitale.it/tutti-i-dati-italia-2017/">Tutti i dati d’Italia 2017</Button></ListItem>
                            <ListItem><Button size="small" href="https://www.destinazionedigitale.it/tutti-i-dati-italia-2016/">Tutti i dati d’Italia 2016</Button></ListItem>
                        </List>
                    </Grid>

                    <Grid item xs={12}>
                        <br/>
                        <br/>
                        <Typography variant="body1" className="shared-footer__copyright">
                            Travel Appeal  2018. All rights reserved. P.IVA 04633420262 |&nbsp;
                            <Button size="small" href="https://www.destinazionedigitale.it/privacy-policy/">Privacy Policy</Button> |&nbsp;
                            <Button size="small" href="https://www.destinazionedigitale.it/privacy-policy/">Cookie Policy</Button>
                        </Typography>
                    </Grid>
                </GridContainer>
                
            </Toolbar>
        </AppBar>
    )
  }
}

export default withStyles(styles)(Footer)


// WEBPACK FOOTER //
// ./src/components/shared/Footer.js